/**
 * Sentry에 사용자 컨텍스트를 설정하는 유틸리티
 * 클라이언트 컴포넌트에서 사용자 정보가 로드된 후 호출
 */
import * as Sentry from '@sentry/react';
import type { User } from '@/shared/types/user';

/**
 * Sentry에 사용자 정보를 설정합니다.
 * @param user 사용자 정보
 */
export function setSentryUser(user: Omit<User, 'is_confirmed'> | null) {
  if (!user) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.name,
    // PII 보호를 위해 추가 정보는 태그로만 설정
  });

  // 사용자 역할을 태그로 추가 (알람 규칙에서 사용 가능)
  Sentry.setTag('user_role', user.role);
}

/**
 * Sentry에 추가 컨텍스트를 설정합니다.
 * @param context 추가 컨텍스트 정보
 */
export function setSentryContext(context: Record<string, unknown>) {
  Sentry.setContext('custom', context);
}
